module.exports = __webpack_public_path__ + "img/no-data.7a3e04a6.png";